// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsBoolean, IsOptional, IsInt, IsNotEmpty, IsString, ValidateNested } from 'class-validator';

export class SymbolForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class TemplateForm {
  @IsInt()
  id: number;

  @IsString()
  @IsNotEmpty()
  name: string;
}

export class TrimbleLayerForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  description: string | null;

  @IsString()
  color: string;

  @IsInt()
  displayPriority: number;

  @IsInt()
  lineweight: number;

  @IsBoolean()
  isPrint: boolean;

  @IsBoolean()
  isProtected: boolean;

  @ValidateNested()
  symbol: SymbolForm;

  @IsOptional()
  @ValidateNested()
  template?: TemplateForm;
}
